@if (disallowStartOptimization()) {
    <nz-alert nzShowIcon nzType="warning" [nzDescription]="alertDescriptionTmpl">
        <ng-template #alertDescriptionTmpl>
            <div class="a-fx-col a-fx-flex">
                <adspt-disallowed-optimization-title class="h4" />
                <adspt-disallowed-optimization-message />
            </div>
        </ng-template>
    </nz-alert>
}
